// The bundle's package.json version, set in craco.config.js. Every API request sends it, so the API
// can log which version each tenant runs and, when MIN_CLIENT_VERSION is set, ask an outdated tab
// to reload. Rules: nxmonorepo/todos/api-versioning.md.
export const clientVersionHeader = 'x-client-version';

export const clientVersion = process.env.REACT_APP_VERSION || 'unknown';

export const clientVersionHeaders = { [clientVersionHeader]: clientVersion };
